import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StickyElementDirective } from './sticky-element.directive';

@NgModule({
  declarations: [StickyElementDirective],
  imports: [
    CommonModule
  ],
  exports: [StickyElementDirective]
})
export class StickyElementModule { }
